//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Rate from '~/components/Rate';

export default {
  name: 'TeacherCard',
  components: { Rate },
  props: {
    item: { type: Object, default: () => {} },
  },
};
